import * as React from "react";
import "./style.scss";

export class MerchantBadge extends React.Component<MerchantBadge.Props, null> {
  render() {
    let { selectedMerchant } = this.props;
    let logoUrl = "/flipp.png";
    let logoPath = selectedMerchant && selectedMerchant.large_image_path;
    if (logoPath && logoPath.length > 0) {
      if (logoPath.includes("http")) {
        logoUrl = logoPath.replace("https:", "").replace("http:", "");
      } else {
        logoUrl = `//images.wishabi.net/${logoPath}`;
      }
    }
    return (
      <div className="merchant-badge" id="merchant-badge">
        {selectedMerchant ? (
          <span style={{ display: "flex", alignItems: "center" }}>
            <img src={logoUrl} />
            <h2> {selectedMerchant.name} </h2>
          </span>
        ) : null}
      </div>
    );
  }
}

export namespace MerchantBadge {
  export interface Props {
    selectedMerchant: any;
  }
}



// WEBPACK FOOTER //
// ./client/modules/common/components/MerchantBadge/index.tsx